import { httpClient } from "@coworker/http-client";
import { CreateTaskTypeDTO, TaskType } from "../types/TaskType";

const NO_TASK_TYPES: TaskType[] = [];

export async function createTaskType(createTaskType: CreateTaskTypeDTO) {
  return httpClient.tasks.post<TaskType>("/task-types", {
    body: createTaskType,
  });
}

export async function getAllTaskTypes(): Promise<TaskType[]> {
  return httpClient.tasks.get<TaskType[]>("/task-types");
}

export async function getTaskTypes(ids: string[]) {
  if (ids.length === 0) {
    return NO_TASK_TYPES;
  }

  return httpClient.tasks.get<TaskType[]>(`/task-types/${ids.join(",")}`);
}

export async function updateTaskType(taskType: TaskType) {
  return httpClient.tasks.put<TaskType>(`/task-types/${taskType.id}`, {
    body: taskType,
  });
}

export async function deleteTaskType(id: string) {
  await httpClient.tasks.delete(`/task-types/${id}`);
}
